import React, { useEffect, useState } from 'react'
import RolesForm from './RolesForm'
import axios from 'axios'

const RolesEditForm = ({ id }) => {
  const [{ role, saveSuccessful, saveText }, setState] = useState({ role: null, saveSuccessful: null, saveText: '' })

  const rolePresent = !!role?.id
  const url = rolePresent ? Routes.api_internal_role_path(role.id, { format: 'json' }) : Routes.api_internal_roles_path({ format: 'json' })

  const saveRole = (role, onFinished) => {
    const action = rolePresent ? 'patch' : 'post'
    axios[action](url, role).then((resp) => {
      setState(prev => ({ ...prev, saveSuccessful: true, saveText: 'Save was successful.' }))
      onFinished(true, null)
      setState(prev => ({ ...prev, role: resp.data }))
    }).catch((error) => {
      setState(prev => ({ ...prev, saveSuccessful: false, saveText: 'Save failed. Please review the values.' }))
      onFinished(false, error.response.data)
    })
  }

  useEffect(() => {
    if (id) {
      axios.get(Routes.api_internal_role_path(id, { format: 'json' })).then((resp) =>
        setState(prev => ({
          ...prev,
          role: resp.data
        }))
      )
    } else {
      setState(prev => ({
        ...prev,
        role: { name: '', permissions: [] }
      }))
    }
  }, [id])

  if (!role) return null

  return (
    <div className="row">
      <div className="col-sm-12">
        {saveSuccessful !== null && (
          <div className={`alert alert-${saveSuccessful ? 'success' : 'danger'}`}>
            {saveText}
          </div>
        )}
        <RolesForm
          id={role.id}
          name={role.name}
          permissions={role.permissions}
          onSubmit={saveRole}
        />
      </div>
    </div>
  )
}

export default RolesEditForm
